var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 96,
    viewBox: "0 0 78 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_4547_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3186 94.4661C88.3186 98.9186 68.5948 102.525 44.243 102.525C19.8913 102.525 0.16748 98.9186 0.16748 94.4661C0.16748 90.4552 16.5122 87.1066 37.7786 86.5547C39.762 88.9465 41.3414 90.9336 41.3781 90.9704L44.1329 94.4661L47.0345 91.044C47.0345 91.044 48.7608 89.0201 50.9646 86.5547C72.1208 87.1434 88.3186 90.4552 88.3186 94.4661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.243 2.80273C60.1072 2.8028 72.9265 15.0596 72.9266 31.7275C72.9266 40.1787 69.7312 49.2299 65.2577 57.4961C60.8011 65.7309 55.1912 72.9745 50.6307 77.7588C48.7 79.7682 46.6233 82.092 45.0389 83.9014C44.7767 84.2009 44.5272 84.4871 44.2938 84.7559C44.0963 84.516 43.8886 84.2617 43.6698 83.998C42.1913 82.216 40.2521 79.9277 38.4501 77.9531L38.4462 77.9492L37.5731 76.9785C33.1418 71.9746 27.8037 64.7115 23.4862 56.7949C18.8512 48.296 15.5595 39.3466 15.5594 31.7646C15.5594 15.7554 28.419 2.80273 44.243 2.80273ZM44.243 14.9502C35.0587 14.9502 27.6385 22.4528 27.6385 31.6543C27.6386 40.8557 35.0587 48.3584 44.243 48.3584C53.4273 48.3583 60.8474 40.8557 60.8475 31.6543C60.8475 22.4528 53.4274 14.9503 44.243 14.9502Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4547_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.e2f969d4f509dcbd46116746513139fc.svg";
export { ForwardRef as ReactComponent };